<template>
  <ScreenWidthProvider v-slot="{ isWider }">
    <HotelNearbyFacilities
      v-if="!isWider('lg')"
      class="mt-4"
      :hotel-info="hotelInfo"
      position="relative"
    />
    <MarkedMapModalPreview
      class="full-width flex"
      :points="[hotelPosition]"
      :see-full-map-button-position="seeFullMapButtonPosition"
    >
      <template #underPreview>
        <HotelNearbyFacilities
          v-if="isWider('lg')"
          :hotel-info="props.hotelInfo"
          position="absolute"
        />
      </template>
    </MarkedMapModalPreview>
  </ScreenWidthProvider>
</template>

<script setup>
const props = defineProps({
  hotelInfo: {
    type: Object,
    required: true,
  },

  seeFullMapButtonPosition: {
    type: String,
    default: 'bottom',
  },
})

const hotelPosition = computed(() => [
  props.hotelInfo.lng,
  props.hotelInfo.lat,
])
</script>
